import { ApiCallResponse } from '@kts-front/call-api';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconX } from '@tabler/icons-react';

import { API_ERROR_TYPE } from 'types/ApiError';
import { isCancelledRequest } from 'utils/isCancelledRequest';

export class NotificationsStore {
  showErrorByResponse(response: ApiCallResponse<any, any>): void {
    if (isCancelledRequest(response)) {
      return;
    }

    const errorType = response?.data?.data?.type;

    if (errorType === API_ERROR_TYPE.companyBlocked || errorType === API_ERROR_TYPE.userBlocked) {
      return;
    }

    notifications.show({
      color: 'red',
      icon: <IconX size={18} />,
      message: response?.data?.data?.message ?? 'Произошла ошибка',
      autoClose: 4000,
    });
  }

  showError({
    message,
    title,
    autoClose,
    id,
    onClose,
  }: {
    message: string;
    title?: string;
    autoClose?: number;
    id?: string;
    onClose?: () => void;
  }): void {
    notifications.show({
      id,
      color: 'red',
      ...(title ? { title } : {}),
      icon: <IconX size={18} />,
      message: message ?? 'Произошла ошибка',
      autoClose: autoClose ?? 4000,
      onClose,
    });
  }

  showSuccess(message: string, title?: string): void {
    notifications.show({
      color: 'teal',
      ...(title ? { title } : {}),
      icon: <IconCheck size={18} />,
      message,
      autoClose: 4000,
    });
  }
}
